// src/pages/ChoosePlanPage.js
import React, { useState } from 'react';
import './SubscriptionPage.css'; // reuse the subscription styles

const fetchJSON = async (url, opts = {}) => {
  const r = await fetch(url, opts);
  const ct = r.headers.get('content-type') || '';
  const body = ct.includes('json') ? await r.json() : await r.text();
  if (!r.ok) throw new Error(body?.detail || body?.message || String(body));
  return body;
};

export default function ChoosePlanPage() {
  const [err, setErr] = useState('');
  const token =
    (typeof localStorage !== 'undefined' &&
      (localStorage.getItem('clairifi_token') || localStorage.getItem('token'))) ||
    '';

  const continueFree = () => {
    // free trial by default → next step in onboarding
    window.location.href = '/dashboard';
  };

  const upgradeCore = async () => {
    try {
      setErr('');
      const { url } = await fetchJSON('/api/billing/checkout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      window.location.href = url;
    } catch (e) {
      setErr(String(e.message || e));
    }
  };

  const signedOut = !token;

  return (
    <div className="sub-wrap">
      <header className="sub-header">
        <div className="sub-eyebrow">PLANS &amp; PRICING</div>
        <h1>Choose your <span className="brand">Clairifi</span> plan</h1>
        <p className="muted">
          Full-stack finance, beautiful insights. Upgrade to <strong>Clairifi Core</strong> for complete access.
        </p>
      </header>

      {err && <div className="sub-alert">{err}</div>}

      <div className="sub-grid">
        {/* Free Trial card */}
        <section className="sub-card sub-card-active">
          <h2>Free Trial</h2>
          <div className="price">
            <span className="price-int">$0</span>
            <span className="per">/month</span>
          </div>
          <ul className="feat">
            <li>14-day access</li>
            <li>Dashboard, Strategy, Forecast</li>
            <li><strong>1 upload</strong> during trial</li>
          </ul>
          <div className="actions">
            {signedOut ? (
              <a className="btn" href="/api/auth/login/google">Continue with Google</a>
            ) : (
              <button className="btn" onClick={continueFree}>Continue free</button>
            )}
          </div>
        </section>

        {/* Core card */}
        <section className="sub-card sub-card-core">
          <div className="ribbon">MOST POPULAR</div>
          <h2>Clairifi Core</h2>
          <div className="price">
            <span className="price-int">$29</span>
            <span className="price-dec">.99</span>
            <span className="per">/month</span>
          </div>
          <ul className="feat">
            <li><strong>Full access</strong> to all tools</li>
            <li><strong>3 uploads</strong> per month</li>
            <li>Priority support</li>
            <li>Cancel anytime</li>
          </ul>
          <div className="actions">
            {signedOut ? (
              <a className="btn" href="/api/auth/login/google">Sign in to upgrade</a>
            ) : (
              <button className="btn" onClick={upgradeCore}>Upgrade to Core — $29.99/mo</button>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}
